const ACTIONS = {
  FETCH_FLEET_SEARCH_INIT: "FETCH_FLEET_SEARCH_INIT",
  FETCH_FLEET_SEARCH_SUCCESS: "FETCH_FLEET_SEARCH_SUCCESS",
  FETCH_FLEET_SEARCH_FAILURE: "FETCH_FLEET_SEARCH_FAILURE",
};

export default ACTIONS;
